import { observer } from 'mobx-react';
import { FC } from 'react';
import { PARTIAL_ACATS_BASE_PATH } from 'modules/Transfer/helper';
import withTransferForm, { PageIdEnum, TransferFormProps } from 'modules/Transfer/withTransferForm';
import BrokerComp from '../../components/Broker';
import { BrokerPageFormutil } from '../../type';

const Broker: FC<TransferFormProps<BrokerPageFormutil>> = observer(props => {
    return <BrokerComp {...props} />;
});

export default withTransferForm({
    id: PageIdEnum.EDIT_BROKER,
    basePath: PARTIAL_ACATS_BASE_PATH,
    showProgressBar: false,
    effect: PageIdEnum.EDIT_CHECK
})(Broker);
